import React, { useState } from 'react';
import Form from '../../components/common/Form';
import FormSection from '../../components/common/FormSection';
import FormField from '../../components/common/FormField';
import { PinDTO } from '../../services/apiClient';
import handleChange from '../../utils/formUtils/handleChange';
import { useFormValidation, ValidationRules } from '../../hooks/useFormValidation';

interface PinFormProps {
  initialValues: PinDTO;
  onSubmit: (data: PinDTO) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const FORM_SECTIONS = {
  basicInfo: {
    id: 'basic-info',
    title: 'Basic Information'
  }
} as const;

const PinForm: React.FC<PinFormProps> = ({
  initialValues,
  onSubmit,
  onCancel,
  isLoading = false
}) => {
  const [formData, setFormData] = useState<PinDTO>(initialValues);

  
            const validationRules: ValidationRules = {
                    name: [
      { required: true, message: 'Name is required' }
    ]
            };

  const { errors, validate } = useFormValidation<PinDTO>(validationRules);

  const handleSave = () => {
    if (validate(formData)) {
      onSubmit(formData);
    }
  };

  const sections = Object.values(FORM_SECTIONS);

  return (
    <Form sections={sections} onSave={handleSave} onCancel={onCancel} isSubmitting={isLoading}>
      <FormSection 
        id={FORM_SECTIONS.basicInfo.id} 
        title={FORM_SECTIONS.basicInfo.title}
      >
                <FormField
          id="name"
          label="Name"
          type="text"
          value={formData.name || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Name"
          required={true}
          error={errors.name}
        />
        <FormField
          id="legacyPinId"
          label="Legacy Pin Id"
          type="text"
          value={formData.legacyPinId || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Legacy Pin Id"
          required={false}
          error={errors.legacyPinId}
        />

      </FormSection>
    </Form>
  );
};

export default PinForm;